import React from "react";
import IPDBillingLayout from "./ipd-billing/components/IPDBillingLayout";
import PricingRuleEngine from "./rule-builder/PricingRuleEngine";

export default function IPDBillingPricing() {
  return (
    <IPDBillingLayout activeNav="pricing">
      <style>{`
        @keyframes ipdFadeIn { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: none; } }
      `}</style>
      <div style={{ padding: "28px 32px" }}>
        <PricingRuleEngine />
      </div>
    </IPDBillingLayout>
  );
}
